module.exports = __webpack_public_path__ + "img/Resume-pic2@2x.c20e3f6c.webp";